<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hJZSYS/tc-custom/9781614174974.jpg?1678668704534" alt="This image is the cover for the book Just Ducky (A Lexie Starr Mystery, Book 5), A Lexie Starr Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Just Ducky (A Lexie Starr Mystery, Book 5), A Lexie Starr Mystery
      </h1>
      <p class="bookDescription body article font2">
        <b>Police Rule Librarian's Death as Suicide, Lexi Starr Disagrees in <i>Just Ducky</i>, a Cozy Mystery by Jeanne Glidewell</b><br/><br/>Lexie Starr, the 50-year-old, newly married co-owner of a B&amp;B, needs something to keep her busy during the off-season. Filling in for the head librarian, Bertha Duckworthy, seems the perfect choice.<br/>Until she finds "Ducky" hanged from the library's rafters.<br/>The police rule the death as a suicide, but Lexie disagrees. Determined to obtain justice for "Ducky", Lexie finds herself in the killer's crosshairs. But with characteristic persistence and armed with caffeine, Lexie is determined to prevail.<br/><br/><b>REVIEWS:</b><br/>". . . Lexie is a character you will love." <i>~Lyn Fisher, Amazon Reviewer</i><br/> "Jeanne Glidewell's mysteries are fast-paced, complex, and have just the right hint of romance." <i>~Jill Churchill, author of the Jane Jeffrey and Grace and Favor mystery series.</i><br/><br/><b>THE LEXIE STARR MYSTERIES,</b> in series order<br/><i>Leave No Stone Unturned<br/>The Extinguished Guest<br/>Haunted<br/>With This Ring<br/>Just Ducky<br/>The Spirit of the Season (A Holiday Novella)<br/>Cozy Camping<br/>Marriage and Mayhem</i><br/><br/><b>THE RIPPLE EFFECT MYSTERIES, </b>in series order<br/><i>A Rip Roaring Good Time<br/>Rip Tide<br/>Ripped to Shreds<br/>Rip Your Heart Out<br/>Ripped Apart<br/>Ripped Off<br/>No Big Rip<br/>The Grim Ripper</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeanne Glidewell
      </h2>
      
      <p class="authorDescription body article">A pancreas/kidney transplant recipient, Jeanne lives in Texas, with her husband and chubby cat. When Jeanne isn&#39;t writing, she&#39;s promoting organ donation and stalking wildlife with her camera.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ePublishing Works!
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1706cf41